// Outcome of a verify-payment call, as the checkout UI needs it:
//   enrolled — payment captured and access granted
//   review   — captured, but the server held it for manual review
//              (under_review): the money was received, access is not granted
//              automatically and a person resolves it. Never ask the learner
//              to pay again.
//   pending  — authorized but not yet captured, or not confirmable right now:
//              never ask the learner to pay again; a later verification of
//              the same order may complete it
//   not_paid — the gateway reports no completed payment for this order
export const interpretVerifyResponse = ({ data, status, body } = {}) => {
  if (status && status >= 200 && status < 300) {
    if (data?.under_review) return { state: "review", message: data?.error };
    if (data?.pending) return { state: "pending" };
    if (data?.success === false) return { state: "pending" };
    return { state: "enrolled" };
  }
  if (
    status === 400 &&
    /not been completed at the gateway/i.test(body?.error || "")
  ) {
    return { state: "not_paid", message: body.error };
  }
  // Signature, ownership or server errors after the learner paid: treat as
  // pending so the UI does not invite a second charge.
  return { state: "pending", message: body?.error };
};
